import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'src/app/rootStore';

const getState = (state: RootState) => state.user;

export const userLogin = createSelector(getState, (state) => state?.userLogin);
export const userEmail = createSelector(getState, (state) => state?.userEmail);
export const userRole = createSelector(getState, (state) => state?.userRole);
export const isLoadingUsersLogin = createSelector(getState, (state) => state?.isLoadingUsersLogin);
export const clientData = createSelector(getState, (state) => state?.clientKeyData);
export const currentClientSelected = createSelector(
  getState,
  (state) => state?.currentSelectedIndex,
);
export const clientId = createSelector(getState, (state) => state?.clientUniqueId);
export const currentView = createSelector(getState, (state) => state?.currentView);
export const cmpAccess = createSelector(getState, (state) => state?.cmpAccess);
export const cmpName = createSelector(getState, (state) => state?.cmpName);
export const isLinkedInConfigured = createSelector(getState, (state) => state?.isLinkedInConfigured);
